export default __webpack_public_path__ + "static/media/Bandit's Legguards of the Howling Moon.91efdf8f.jpg";